
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.7 21c-.4.4-1 .4-1.4 0L3 12.7c-.4-.4-.4-1 0-1.4L11.3 3c.4-.4 1-.4 1.4 0l8.3 8.3c.4.4.4 1 0 1.4L12.7 21zm-7.8-9.7c-.4.4-.4 1 0 1.4l6.4 6.4c.4.4 1 .4 1.4 0l6.4-6.4c.4-.4.4-1 0-1.4l-6.4-6.4c-.4-.4-1-.4-1.4 0l-6.4 6.4z"}}),_c('path',{attrs:{"d":"M8 11.3L11.4 8c.4-.4.9-.4 1.3 0l3.4 3.4c.4.4.4 1 0 1.3L12.6 16c-.4.4-.9.4-1.3 0L8 12.7c-.4-.4-.4-1 0-1.4z"}})])
          )
        }
      }
    